import React from 'react'

const Men = () => {
    return (
        <div className="men container">
            <h1 className="h1">Men</h1>
        </div>
    )
}

export default Men
